module.exports = __webpack_public_path__ + "static/media/jones-engineering.40ce205b.png";